export const SET_SITE_DATA = '@siteDataset/SET_SITE_DATA';
